//any hardcoded values should be added here
//https://corsproxy.io/?

// export const getAllRestaurantsURL = `https://api.allorigins.win/get?url=${encodeURIComponent(
//   "https://www.swiggy.com/dapi/restaurants/list/v5?lat=18.481361&lng=73.8754846&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING"
// )}`;

export const getAllRestaurantsURL =
  "https://expresspj.onrender.com/api/eatvilla/getAllRestaurants";

export const getRestaurantByIdURL =
  "https://expresspj.onrender.com/api/eatvilla/getRestaurants/";

export const cloudinaryImageURL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

// `https://api.allorigins.win/get?url=${encodeURIComponent(
//         "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/"
//       )}`
